import * as _ from 'lodash';

import { ReorderArticle, ReorderArticleSize, ReorderPrepack } from 'app/b2b-order/types/reorder';
import { PreorderArticle } from 'app/b2b-order/types/preorder';
import { getMatrixSelectedAmount } from 'app/b2b-order/helpers/order';

export class Validator {
    public noArticleSelectedForOrder(articles: ReorderArticle[] | PreorderArticle[]): boolean {
        return _.every(
            articles,
            (article: ReorderArticle | PreorderArticle) =>
                _.every(
                    article.sizes,
                    (size: ReorderArticleSize) => getMatrixSelectedAmount(size.stock.selectedAmount) === 0
                ) && _.every(article.prepacks, (prepack: ReorderPrepack) => prepack.stock.selectedAmount === 0)
        );
    }

    public allArticleAmountsValid(articles: ReorderArticle[] | PreorderArticle[]): boolean {
        const firstArticle = _.first(articles as (ReorderArticle | PreorderArticle)[]);
        if (this.isReorderArticle(firstArticle)) {
            return _.every(articles, ({ stock }: ReorderArticle) => stock.validSelectedAmount === true);
        }

        return _.every(articles, { validAmount: true });
    }

    private isReorderArticle(article: ReorderArticle | PreorderArticle) {
        return !!_.get(article, 'stock');
    }
}
